'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<path d="M12.12 11.001c0 .62-.5 1.12-1.12 1.12-.62 0-1.12-.5-1.12-1.12v-4c0-.62.5-1.12 1.12-1.12.62 0 1.12.5 1.12 1.12v4zm-2.24 3c0-.62.5-1.12 1.12-1.12.62 0 1.12.5 1.12 1.12 0 .62-.5 1.12-1.12 1.12-.62 0-1.12-.5-1.12-1.12zm11.83-3.71l-10-9.998a1.008 1.008 0 0 0-1.42 0l-10 9.998c-.18.19-.29.44-.29.71 0 .26.11.52.29.7l10 10.01c.19.18.44.29.71.29.27 0 .52-.11.71-.29l10-10.01c.181-.18.29-.44.29-.7 0-.27-.109-.52-.29-.71z"/><!-- Filename: sourceSvg/notifications/error_selected.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 22'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};